import { Author } from './models';
import ludwig from '../assets/images/authors/ludwig.jpg';

export const AuthorMap: { [key in Author]: { link?: string; img: string } } = {
    [Author.LinusLuering]: {
        img: 'https://img.br.de/be4b8799-f8f1-4e88-b93d-c826ab2226df.png?rect=0%2C0%2C180%2C180&_v=1625144213816'
    },
    [Author.SteffenKuehne]: {
        link: 'https://www.br.de/nachrichten/autoren/steffen-kuehne,a23634a8-d1bd-47ca-bc5a-bf605c53b6ca',
        img:
            'https://img.br.de/4337b636-3036-4328-91b4-79d441807657.jpeg?_v=1605527775396&rect=745%2C112%2C1416%2C1417&w=250'
    },
    [Author.LudwigSpitaler]: {
        img: ludwig
    }
};
